<template>
    <div class="registered">
      <div class="banner">
        <div class="content">
			<div class="item">版权保护</div>
			<div class="item">尊重创作</div>
			<div class="item">促进发展</div>
        </div>
      </div>
	  <div class="mainBox">
			<div class="process">
				<div class="title">用户注册</div>
				<div class="msg">著作权人基本信息填写</div>
				<div class="itemBox">
					<div class="item">
						<img class="iocn" src="../assets/r11.png" alt="">
						<div class="line activeL"></div>
						<div class="text activeT">基本信息填写</div>
					</div>
					<div class="item">
						<img class="iocn" src="../assets/r2.png" alt="">
						<div class="line"></div>
						<div class="text">实名信息填写</div>
					</div>
					<div class="item">
						<img class="iocn" src="../assets/r3.png" alt="">
						<div class="line"></div>
						<div class="text">联系信息填写</div>
					</div>
					<div class="item">
						<img class="iocn" src="../assets/r4.png" alt="">
						<div class="line"></div>
						<div class="text">注册完成</div>
					</div>
				</div>
			</div>
			<div class="information" v-if="processData == 1">
					<div class="title">基本信息填写</div>
					<div class="form">
						<div class="left">
								<div class="item">
									<div class="lable"><span>*</span>用户名</div>
									<el-input class="elinput" v-model="input" placeholder="3-20个字符，包括大小写字母、数字、下划线、不允许有空格！"></el-input>
								</div>
								<div class="item">
									<div class="lable"><span>*</span>密码</div>
									<el-input class="elinput" v-model="input" placeholder="长度为6-18个字符，支持数字、字母，不允许有空格！"></el-input>
								</div>
								<div class="item">
									<div class="lable"><span>*</span>确认密码</div>
									<el-input class="elinput" v-model="input" placeholder="请再次确认密码"></el-input>
								</div>
						</div>
						<div class="right">
							温馨提示：<br>带*的为必填项，请根据提示填写完整
						</div>
					</div>
					<div class="btnBox">
						<div class="cz" @click="onChongzhi()">重置</div>
						<div class="cxybz">下一步</div>
					</div>
			</div>
			<div class="information" v-if="processData == 2">
				<div class="title">实名信息填写</div>
				<div class="form">
					<div class="left">
						<div class="item">
							<div class="lable2"><span>*</span>真实姓名/单位名称</div>
							<el-input class="elinput" v-model="input" placeholder="最大长度为100个字符、不能包含特殊字符、请用中文简体填写"></el-input>
						</div>
						<div class="item">
							<div class="lable2"><span>*</span>用户类型</div>
							<Select class="elinput" :clearable="true" v-model="input" placeholder="请选择用户所属类型">
								<Option v-for="(item, index) in 4" :value="index" :key="index">区域一{{index}}</Option>
							</Select>
						</div>
						<div class="item">
							<div class="lable2"><span>*</span>证件类型</div>
							<Select class="elinput" :clearable="true" v-model="input" placeholder="请选择证件所属类型">
								<Option v-for="(item, index) in 4" :value="index" :key="index">区域一{{index}}</Option>
							</Select>
						</div>
						<div class="item">
							<div class="lable2"><span>*</span>证件上传</div>
							<div class="upImgBox" v-if="typeUpImg == 'personal'">
								<div class="list">
									<el-upload
										class="avatar-uploader"
										action="https://jsonplaceholder.typicode.com/posts/"
										:show-file-list="false"
										>
										<img v-if="cardImgZ" :src="cardImgZ" class="avatar">
										<img v-else class="avatar" src="../assets/cardZ.png" alt="">
										<div class="textMsg">点击上传身份证人像面照片</div>
									</el-upload>
								</div>
								<div class="list">
									<el-upload
										class="avatar-uploader"
										action="https://jsonplaceholder.typicode.com/posts/"
										:show-file-list="false"
										>
										<img v-if="cardImgF" :src="cardImgF" class="avatar">
										<img v-else class="avatar" src="../assets/cardF.png" alt="">
										<div class="textMsg">点击上传身份证国徽面照片</div>
									</el-upload>
								</div>
								<div class="list">
									<el-upload
										class="avatar-uploader"
										action="https://jsonplaceholder.typicode.com/posts/"
										:show-file-list="false"
										>
										<img v-if="cardImgS" :src="cardImgS" class="avatar">
										<img v-else class="avatar" src="../assets/cardS.png" alt="">
										<div class="textMsg">点击上传手持身份证照片</div>
									</el-upload>
								</div>
							</div>
							<div class="upImgBox" v-if="typeUpImg == 'enterprise'">
								<div class="list enterprise">
									<el-upload
										class="avatar-uploader"
										action="https://jsonplaceholder.typicode.com/posts/"
										:show-file-list="false"
										>
										<img v-if="enterpriseImg" :src="enterpriseImg" class="avatar">
										<img v-else class="avatar" src="../assets/cardZ.png" alt="">
										<div class="textMsg">点击上传营业执照照片</div>
									</el-upload>
								</div>
							</div>
							<div class="upImgBox" v-if="typeUpImg == 'institutions'">
								<div class="list enterprise">
									<el-upload
										class="avatar-uploader"
										action="https://jsonplaceholder.typicode.com/posts/"
										:show-file-list="false"
										>
										<img v-if="enterpriseImg" :src="enterpriseImg" class="avatar">
										<img v-else class="fadd" src="../assets/fadd.png" alt="">
										<div class="textMsg">点击上传组织机构代码/统一社会信用代码证书照片</div>
									</el-upload>
								</div>
							</div>
							<div class="upImgBox" v-if="typeUpImg == 'orderImg'">
								<div class="list enterprise">
									<el-upload
										class="avatar-uploader"
										action="https://jsonplaceholder.typicode.com/posts/"
										:show-file-list="false"
										>
										<img v-if="enterpriseImg" :src="enterpriseImg" class="avatar">
										<img v-else class="fadd" src="../assets/fadd.png" alt="">
										<div class="textMsg">点击上传其他证书照片</div>
									</el-upload>
								</div>
							</div>
						</div>
						<div class="item">
							<div class="lable2"><span>*</span>证件号</div>
							<el-input class="elinput" v-model="input" placeholder="请输入或核对有效证件号"></el-input>
						</div>
						<div class="item">
							<div class="lable2"><span>*</span>证件有效期限</div>
							<div class="timeBox">
								<div class="list">
									<DatePicker class="elinput" type="date" v-model="dateTime" placeholder="开始时间" ></DatePicker>
								</div>
								<div class="list">
									<Select class="elinput" :clearable="true" v-model="input" placeholder="有期限（请选择日期）">
										<Option v-for="(item, index) in 4" :value="index" :key="index">区域一{{index}}</Option>
									</Select>
								</div>
								<div class="list">
									<DatePicker class="elinput" type="date" v-model="dateTime" placeholder="结束时间" ></DatePicker>
								</div>
							</div>
						</div>
					</div>
					<div class="right">
						上传证件要求：<br>
						1、上传的证件内容必须清晰可见；<br>
						2、作者名称和证件号码与提交的证件信息一致；<br>
						3、要求不得涂改，需确保四边角完整，水印、文字、图片、证件号码等清晰可辨；<br>
						4、须小于10MB，且为jpg/png/ipeg/bmp格式，尺寸过小不宜上传；<br>
						5、证件在有效期之内；<br>

						注意：<br>
						1.双手持身份证，手指不可遮挡身份证信息； <br>
						2.照片需免冠，五官清晰可见；<br>
						3.照片内容真实有效，不得任何修改。<br>
					</div>
				</div>
				<div class="btnBox">
					<div class="cz" @click="onChongzhi()">重置</div>
					<div class="cxybz">下一步</div>
				</div>
		 	</div>
			<div class="information" v-if="processData == 3">
				 <div class="title">联系信息填写</div>
				<div class="form">
					<div class="left left2">
						<div class="item">
							<div class="lable2"><span>*</span>联系地址</div>
							<el-input class="elinput" v-model="input" placeholder="请详细填写您的邮寄地址，不得超过200个字符"></el-input>
						</div>
						<div class="item">
							<div class="lable2"><span>*</span>邮编</div>
							<el-input class="elinput" v-model="input" placeholder="邮编为6位数字"></el-input>
						</div>
						<div class="item">
							<div class="lable2"><span>*</span>联系人</div>
							<el-input class="elinput" v-model="input" placeholder="请填写联系人"></el-input>
						</div>
						<div class="item">
							<div class="lable2"><span>*</span>手机</div>
							<el-input class="elinput" v-model="input" placeholder="手机号为11位数字，用于短信通知"></el-input>
						</div>
						<div class="item">
							<div class="lable2">联系电话</div>
							<el-input class="elinput" v-model="input" placeholder="请填写座机（格式如：020-61292236）"></el-input>
						</div>
						<div class="item">
							<div class="lable2">传真</div>
							<el-input class="elinput" v-model="input" placeholder="请填写座机（格式如：020-61292236）"></el-input>
						</div>
						<div class="item">
							<div class="lable2"><span>*</span>Email</div>
							<el-input class="elinput" v-model="input" placeholder="请填写邮箱"></el-input>
							<div class="msg">邮箱极其重要！登记相关信息将发送至该邮箱！</div>
						</div>
						<div class="item">
							<div class="lable2"><span>*</span>用户来源地</div>
							<div class="timeBox">
								<div class="list">
									<Select class="elinput" :clearable="true" v-model="input" placeholder="请选择国家">
										<Option v-for="(item, index) in 4" :value="index" :key="index">区域一{{index}}</Option>
									</Select>
								</div>
								<div class="list">
									<Select class="elinput" :clearable="true" v-model="input" placeholder="请选择省或州">
										<Option v-for="(item, index) in 4" :value="index" :key="index">区域一{{index}}</Option>
									</Select>
								</div>
								<div class="list">
									<Select class="elinput" :clearable="true" v-model="input" placeholder="请选择城市">
										<Option v-for="(item, index) in 4" :value="index" :key="index">区域一{{index}}</Option>
									</Select>
								</div>
							</div>
							<div class="msg">请按照身份证明填写</div>
						</div>
						<div class="item">
							<div class="lable2"><span>*</span>选择用户所属行业</div>
							<Select class="elinput" :clearable="true" v-model="input" placeholder="单位用户请选择所属行业类型">
								<Option v-for="(item, index) in 4" :value="index" :key="index">区域一{{index}}</Option>
							</Select>
						</div>
						<div class="item">
							<div class="lable2"><span>*</span>选择登记办理地点</div>
							<div class="timeBox">
								<div class="list">
									<Select class="elinput2 " :clearable="true" v-model="input" placeholder="请选择城市">
										<Option v-for="(item, index) in 4" :value="index" :key="index">区域一{{index}}</Option>
									</Select>
								</div>
								<div class="list">
									<Select class="elinput2" :clearable="true" v-model="input" placeholder="请选择登记办理点（请就近选择）">
										<Option v-for="(item, index) in 4" :value="index" :key="index">区域一{{index}}</Option>
									</Select>
								</div>
							</div>
						</div>
						<div class="item">
							<div class="lable2"></div>
							<div class="passKeep">
								<div class="iocn"></div>
								<div class="text">我已阅读并接受<span>《注册须知》</span></div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="btnBox">
					<div class="cz" >上一步</div>
					<div class="cz" @click="onChongzhi()">重置</div>
					<div class="cxybz">注册</div>
				</div>
			</div>
			<div class="successBox" v-if="processData == 4">
				<img class="success" src="../assets/success.png" alt="">
				<div class="title">恭喜，您已成功提交用户注册申请</div>
				<div class="msg">我们会尽快审核您的信息，一旦您通过我们的认证将会以短信形式通知您请注意查收！</div>
				<div class="btnBox">
					<div class="cz" >返回首页</div>
					<div class="cxybz">立即登录</div>
				</div>
			</div>
	  </div>
	  <logindDalog ref="logindDalog"></logindDalog>
    </div>
</template>

<script>
	import logindDalog from '../components/logindDalog.vue'
    export default {
        name: "gananRegistered",
        data(){
            return {
                input: '',
				processData: 4, // 步骤
				cardImgZ: require('../assets/正面.jpg'), //身份证正面
				cardImgF: '', //身份证反面
				cardImgS: '', //身份证手持
				value1: '',
				dateTime: '',
				enterpriseImg: '', //企业证件
				typeUpImg: 'personal' // personal 个人 enterprise 企业  institutions 机构 orderImg 其他证件
            }
        },
		components: {
			logindDalog
		},
        methods: {
			onChongzhi() {
				this.$refs.logindDalog.dialogTableVisible = true
			}
        },
        watch: {
            $route(to, from) {

            }
        }
    };
</script>

<style lang="less" scoped>
.registered{
	background: #F4F8FC;
}
.banner{
    height: 149px;
    background: url('../assets/zhubg.png') no-repeat;
    background-size: cover;
    .content{
		width: 1200px;
		margin: auto;
		display: flex;
		align-items: center;
		height: 149px;
		justify-content: center;
		.item{
			font-size: 44px;
			font-weight: 700;
			color: #fff;
			margin: 0 60px;
		}
    }
}
.mainBox{
	width: 1200px;
	margin: auto;
	padding-bottom: 30px;
	.process{
		background: #fff;
		padding: 33px 48px;
		margin-top: 30px;
		border-radius: 8px;
		.title{
			font-size: 22px;
			color: #333333;
			font-weight: 700;
			text-align: center;
		}
		.msg{
			text-align: center;
			font-size: 14px;
			color: #999999;
			margin-top: 6px;
		}
		.itemBox{
			display: flex;
			align-items: center;
			margin-top: 32px;
			.item{
				flex: 1;
				.iocn{
					width: 53px;
					height: 53px;
					margin: auto;
				}
				.line{
					width: 100%;
					height: 1px;
					background: #E5E5E5;
					margin-top: 25px;
					position: relative;
					&::after{
						content: '';
						position: absolute;
						width: 9px;
						height: 9px;
						border-radius: 100%;
						background: #999;
						top: 50%;
						left: 50%;
						transform: translate(-50%,-50%);
					}
					&::before{
						content: '';
						position: absolute;
						width: 15px;
						height: 15px;
						border-radius: 100%;
						background: #999;
						opacity: 0.2;
						top: 50%;
						left: 50%;
						transform: translate(-50%,-50%);
					}
				}
				.activeL{
					background: #2196F3;
					&::after{
						content: '';
						position: absolute;
						width: 9px;
						height: 9px;
						border-radius: 100%;
						background: #2196F3;
						top: 50%;
						left: 50%;
						transform: translate(-50%,-50%);
					}
					&::before{
						content: '';
						position: absolute;
						width: 15px;
						height: 15px;
						border-radius: 100%;
						background: #2196F3;
						opacity: 0.2;
						top: 50%;
						left: 50%;
						transform: translate(-50%,-50%);
					}
				}
				.text{
					font-size: 14px;
					font-weight: 700;
					color: #999;
					text-align: center;
					margin-top: 11px;
				}
				.activeT{
					color: #2196F3;
				}
			}
		}
	}
	.information{
		background: #fff;
		padding: 33px 38px;
		margin-top: 30px;
		border-radius: 8px;
		.title{
			font-size: 20px;
			font-weight: 700;
			position: relative;
			z-index: 2;
			&::before{
				content: '';
				position: absolute;
				width: 36px;
				background: #2196F3;
				height: 6px;
				border-radius: 3px;
				left: 0;
				bottom: 3px;
				z-index: -1;
			}
		}
		.form{
			display: flex;
			align-items: flex-end;
			padding: 52px 0;
			.left{
				flex: 0 0 775px;
				margin-right: 47px;
				.item{
					display: flex;
					align-items: center;
					margin-bottom: 16px;
					.msg{
						color: #BDBDBD;
						font-size: 14px;
						line-height: 40px;
						margin-left: 47px;
					}
					.lable{
						flex: 0 0 80px;
						font-size: 14px;
						color: #333;
						font-weight: 700;
						text-align: right;
						margin-right: 15px;
						span{
							color: #E70000;
						}
					}
					.lable2{
						flex: 0 0 130px;
						font-size: 14px;
						color: #333;
						font-weight: 700;
						text-align: right;
						margin-right: 15px;
						span{
							color: #E70000;
						}
					}
					.elinput{
						flex: 1;
					}
					.upImgBox{
						display: flex;
						align-items: center;
						.list{
							width: 198px;
							height: 152px;
							border: solid 1px #E5E5E5;
							padding: 12px;
							border-radius: 4px;
							margin-right: 17PX;
							.avatar{
								width: 100%;
								height: 98px;
								margin: auto;
							}
							.fadd{
								width: 122px;
								height: 122px;
								margin: auto;
							}
							/deep/ .el-upload{
								width: 100%;
							}
							.textMsg{
								text-align: center;
								font-size: 12px;
								color: #BDBDBD;
								margin-top: 12px;
							}
						}
						.enterprise{
							height: auto;
							min-height: 152px;
							.avatar{
								width: 100%;
								height: auto;
								min-height: 98px;
								margin: auto;
							}
						}
					}
					.timeBox{
						display: flex;
						align-items: center;
						.list{
							margin-right: 17px;
							&:last-child{
								margin-right: 0;
							}
						}
					}
					/deep/ .ivu-select{
						width: 198px;
					}
					/deep/ .ivu-date-picker-rel{
						width: 198px;
					}
					.elinput2{
						width: 306px;
						/deep/ .ivu-date-picker-rel{
							width: 306px;
						}
					}
					/deep/ .ivu-select-single{
						.ivu-select-selection{
							height: 40px;
						}
						.ivu-select-placeholder{
							height: 40px;
							line-height: 40px;
						}
						.ivu-select-selected-value{
							height: 40px;
							line-height: 40px;
						}
					}
					/deep/ .ivu-input-suffix{
						i{
							height: 40px;
							line-height: 40px;
							&::before{
								content: url('../assets/iocnR.png');
							}
						}
					}
					/deep/ .ivu-input{
						height: 40px;
						line-height: 40px;
						padding-top: 0;
						padding-bottom: 0;
					}
				}
			}
			.left2{
				flex: 1;
				margin-right: 0;
				.elinput{
					flex: 0 0 628px !important;
				}
			}
			.right{
				color: #BDBDBD;
				font-size: 14px;
				line-height: 30px;
				flex: 1;
				margin-bottom: 16px;
			}
		}
		.btnBox{
			display: flex;
			align-items: center;
			justify-content: center;
			padding-bottom: 30px;
			.cz{
				font-size: 14px;
				color: #999999;
				text-align: center;
				width: 170px;
				height: 40px;
				line-height: 40px;
				border-radius: 4px;
				border: 1px solid #E5E5E5;
				margin: 0 10px;
				text-align: center;
				cursor: pointer;
			}
			.cxybz{
				width: 170px;
				height: 40px;
				background: #2196F3;
				line-height: 40px;
				border-radius: 4px;
				margin: 0 10px;
				color: #fff;
				text-align: center;
				cursor: pointer;
			}
		}
		.passKeep{
			display: flex;
			align-items: center; 
			font-size: 14px;
			color: #999;
			margin-top: 15px;
			.iocn{
				width: 14px;
				height: 14px;
				border: solid 1px #999;
				border-radius: 4px;
				margin-right: 4px;
			}
			span{
				color: #2196F3;
			}
		}
	}	
	.successBox{
		background: #fff;
		padding: 90px;
		margin-top: 30px;
		.success{
			width: 150px;
			height: 150px;
			margin: auto;
		}
		.title{
			text-align: center;
			font-size: 16px;
			font-weight: 700;
			margin-top: 36px;
		}
		.msg{
			font-size: 14px;
			color: #999999;
			margin-top: 12px;
			text-align: center;
		}
		.btnBox{
			display: flex;
			align-items: center;
			justify-content: center;
			padding-bottom: 10px;
			margin-top: 46px;
			.cz{
				font-size: 14px;
				color: #999999;
				text-align: center;
				width: 170px;
				height: 40px;
				line-height: 40px;
				border-radius: 4px;
				border: 1px solid #E5E5E5;
				margin: 0 10px;
				text-align: center;
				cursor: pointer;
			}
			.cxybz{
				width: 170px;
				height: 40px;
				background: #2196F3;
				line-height: 40px;
				border-radius: 4px;
				margin: 0 10px;
				color: #fff;
				text-align: center;
				cursor: pointer;
			}
		}
	}
}
</style>
